"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_1 = require(36);
function withHandlers(handlers) {
    return create_1.create({
        initialize: function () {
            var _this = this;
            Object.keys(handlers).forEach(function (k) {
                var _a;
                var v = handlers[k];
                _this.set((_a = {},
                    _a[k] = function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        return v(_this.props, _this.providers).apply(void 0, args);
                    },
                    _a));
            });
        },
    });
}
exports.withHandlers = withHandlers;
//# sourceMappingURL=withHandlers.js.map